export default function PersonalProfile({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Personal Profile")}</legend>
      <input
        className="form-control fontsize-legend"
        name="personalProfile"
        onChange={onChange}
        value={searchObject.personalProfile || ""}
      />
    </div>
  );
}
